import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TaskboardViewComponent } from './actionviews/taskboard-view/taskboard-view.component';
import { MpcBoardViewComponent } from './actionviews/mpc-board-view/mpc-board-view.component';
import { KanbanBoardViewComponent } from './actionviews/kanban-board-view/kanban-board-view.component';
import { Sprintplanning2ViewComponent } from './actionviews/sprintplanning2-view/sprintplanning2-view.component';
import { ReleasePlanningViewComponent } from './actionviews/release-planning-view/release-planning-view.component';
import { LoginViewComponent } from './actionviews/login-view/login-view.component';

const routes: Routes = [
  { path: 'taskboard', component: TaskboardViewComponent },
  { path: 'releaseplanning', component: ReleasePlanningViewComponent },
  { path: 'sprintplanning2', component: Sprintplanning2ViewComponent },
  { path: 'mpc-board', component: MpcBoardViewComponent },
  { path: 'kanban-board', component: KanbanBoardViewComponent },
  { path: 'login', component: LoginViewComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
  })

export class AppRoutingModule {
}
